// extracted by mini-css-extract-plugin
export default {"galleryThumbnail":"c-n_fu","galleryThumbnail_active":"c-n_fv","galleryThumbnail__image":"c-n_fw"};